(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.PostIt = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var PostIt = require('./postit');
var instances = {};

/**
 * Factory Module.
 * @public
 */

var Factory = module.exports = {};

/**
 * Creates a `PostIt` factory (Singleton).
 * @param {string} id
 * @returns {object}
 * @public
 */

Factory.add = function(id) {
	var instance = instances[id];

	// If a given `instance` is found, use it and RETURN EARLY.
	if (instance) {
		return instance;
	}

	// Otherwise, create a new `instance` and store it.
	return (instances[id] = new PostIt(id));
};

/**
 * Removes an explicit `PostIt`, factory instance.
 * @param {string} id
 * @returns {void}
 * @public
 */

Factory.remove = function(id) {
	delete instances[id];
};

/**
 * Gets an explicit `PostIt`, factory instance.
 * @param {string} id
 * @returns {object}
 * @public
 */

Factory.get = function(id) {
	return instances[id];
};

/**
 * Gets all `PostIt`, factory instances.
 * @returns {object}
 * @public
 */

Factory.getAll = function() {
	return instances;
};

},{"./postit":4}],2:[function(require,module,exports){
'use strict';

/**
 * Helpers Module.
 * @public
 */

var helpers = module.exports = {};

/**
 * Serializes an object into a formatted string.
 * @param {object} params
 * @returns {string}
 * @public
 */

helpers.serialize = function(params) {
	var _params = [];

	for (var param in params) {
		_params.push(param + '=' + params[param]);
	}

	return _params.join(', ');
};

/**
 * Merges a shallow `source` object into the `destination` object.
 * @param {object} destination
 * @param {object} source
 * @returns {object}
 * @public
 */

helpers.shallowMerge = function(destination, source) {
	for (var prop in source) {
		if (null != source[prop]) {
			destination[prop] = source[prop];
		}
	}

	return destination;
};

/**
 * Loads a resource into a new browsing context (`window`).
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/open|Window.open()} for more options.
 * @param {string} url
 * @param {string} name
 * @param {object} options
 * @param {number} options.width
 * @param {number} options.height
 * @returns {object}
 * @public
 */

/* istanbul ignore next */
helpers.openWindow = function(url, name, options) {
	options = options || {};

	var that = this;
	var nativeScreen = screen || {};
	var nativeWindow = window;
	var nativeDocument = document;
	var nativeDocumentElement = nativeDocument.documentElement || {};
	var dualScreenLeft = nativeWindow.screenLeft || nativeScreen.left || 0;
	var dualScreenTop = nativeWindow.screenTop || nativeScreen.top || 0;
	var width = nativeWindow.innerWidth || nativeDocumentElement.clientWidth || nativeScreen.width || 0;
	var height = nativeWindow.innerHeight || nativeDocumentElement.clientHeight || nativeScreen.height || 0;
	var left = ((width / 2) - (options.width / 2)) + dualScreenLeft;
	var top = ((height / 2) - (options.height / 2)) + dualScreenTop;
	var features = that.serialize(that.shallowMerge({
		top: top,
		left: left
	}, options));
	var newWindow = nativeWindow.open(url, name, features);

	if (nativeWindow.focus) {
		newWindow.focus();
	}

	return newWindow;
};

},{}],3:[function(require,module,exports){
'use strict';

var Factory = require('./factory');
var helpers = require('./helpers');

/**
 * Manager Module.
 * @public
 */

var Manager = module.exports = {};

/**
 * Creates and manages a `PostIt` instance (`id`).
 * @param {string} id
 * @returns {object}
 * @public
 */

Manager.add = function(id) {
	var that = this;

	if ('string' !== typeof id) {
		console.warn(id + ' should be a `String`.');

		return that;
	}

	// Create a memoized factory.
	Factory.add(id);

	return that;
};

/**
 * Removes a `PostIt` instance (`id`).
 * @param {string} id
 * @returns {object}
 * @public
 */

Manager.remove = function(id) {
	var that = this;
	var record = that.get(id);

	if (!record) {
		return that;
	}

	// Remove listeners to avoid memory leaks.
	for (var event in record.listeners) {
		record.off(event);
	}

	Factory.remove(id);

	return that;
};

/**
 * Removes all `PostIt` instances.
 * @return {object}
 * @public
 */

Manager.removeAll = function() {
	var that = this;
	var records = that.getAll();

	for (var record in records) {
		that.remove(record);
	}

	return that;
};

/**
 * Returns the length of all `PostIt` instances.
 * @return {number}
 * @public
 */

Manager.size = function() {
	var size = 0;
	var records = this.getAll();

	for (var record in records) {
		size++;
	}

	return size;
};

/**
 * Gets a `PostIt` instance (`id`).
 * @param {string} id
 * @returns {object|void}
 */

Manager.get = function(id) {
	return Factory.get(id) || console.warn(id + ' does not match any `PostIt` instances.');
};

/**
 * Gets all `PostIt` instances.
 * @returns {object}
 */

Manager.getAll = function() {
	return Factory.getAll();
};

/**
 * @see {@link postit.md#PostIt+on} for further information.
 * @param {string} id
 * @param {string} event
 * @param {function} listener
 * @returns {object}
 * @public
 */

Manager.on = function(id, event, listener) {
	var that = this;
	var record = that.get(id);

	if (!record) {
		return that;
	}

	record.on(event, listener);

	return that;
};

/**
 * @see {@link postit.md#PostIt+off} for further information.
 * @param {string} id
 * @param {string} event
 * @param {function=} listener
 * @returns {object}
 * @public
 */

Manager.off = function(id, event, listener) {
	var that = this;
	var record = that.get(id);

	if (!record) {
		return that;
	}

	record.off(event, listener);

	return that;
};

/**
 * @see {@link postit.md#PostIt+emit} for further information.
 * @param {string} id
 * @param {string} event
 * @param {object} target
 * @param {string|array|object} message
 * @param {string} origin
 * @returns {object}
 * @public
 */

Manager.emit = function(id, event, target, message, origin) {
	var that = this;
	var record = that.get(id);

	if (!record) {
		return that;
	}

	record.emit(event, target, message, origin);

	return that;
};

/**
 * @see {@link helpers.md#helpers.openWindow} for further information.
 * @param {string} url
 * @param {string} name
 * @param {object} options
 * @param {number} options.width
 * @param {number} options.height
 * @public
 */

Manager.openWindow = function(url, name, options) {
	return helpers.openWindow(url, name, options);
};

},{"./factory":1,"./helpers":2}],4:[function(require,module,exports){
'use strict';

/**
 * PostIt Module.
 * @constructor
 * @param {string} id
 * @public
 */

var PostIt = module.exports = function(id) {
	this.id = id;
	this.nextGuid = 0;
	this.listeners = {};
};

/**
 * Registers a `listener` to a `PostIt` instance (`id`), for a given `event`.
 * @param {string} event
 * @param {function} listener
 * @returns {object}
 * @public
 */

PostIt.prototype.on = function(event, listener) {
	var that = this;

	var listeners = that.listeners[event] = that.listeners[event] || [];
	listener.guid = that.nextGuid++;
	listeners.dispatcher = dispatcher;

	listeners.push(listener);

	function dispatcher(evt) {
		var data = null;

		if (/__postit\s?"/.test(evt.data)) {
			try {
				data = evt.dataParsed = JSON.parse(evt.data);
			} catch (err) {
				console.error(err);
			}
		}

		if (!data || // The preferred symbol (`__postit`) is not present, or an 'Uncaught SyntaxError' occurs, whilst parsing `evt.data` => RETURN EARLY,
			that.id !== data.__id || // or an instance identifier does not match => RETURN EARLY,
			(event !== data.__event && '*' !== event) || // or an event does not match, and an asterisk (*) is not the event => RETURN EARLY
			('null' !== evt.origin && -1 === data.__origin.indexOf(evt.origin)) // or `'null'` is not the `evt.origin`, and the origins do not match. => RETURN EARLY
		) {
			return;
		}

		for (var i = 0; i < listeners.length; ++i) {
			listeners[i].call(this, evt);
		}
	}

	// Only attach one dispatcher per `event`.
	if (listeners.length === 1) {
		window.addEventListener('message', dispatcher, false);
	}

	return that;
};

/**
 * - If a `listener` is not provided, then unregister all listeners from a `PostIt` instance (`id`), for a given `event`.
 * - If a `listener` is provided, then unregister a `listener` from a `PostIt` instance (`id`), for a given `event`.
 * @param {string} event
 * @param {function=} listener
 * @returns {object}
 * @public
 */

PostIt.prototype.off = function(event, listener) {
	var that = this;
	var listeners = that.listeners[event] || [];

	for (var i = 0; i < listeners.length; ++i) {
		if (!listener || listener.guid === listeners[i].guid) {
			listeners.splice(i--, 1);
		}
	}

	if (!listeners.length) {
		window.removeEventListener('message', listeners.dispatcher, false);

		delete that.listeners[event];
	}

	return that;
};

/**
 * - If `event` is an asterisk (\*), then emit an `event` to all listeners registered to a `PostIt` instance (`id`), for all given `event`s.
 * - If `event` is not an asterisk (\*), then emit an `event` to all listeners registered to a `PostIt` instance (`id`), for a given `event`.
 * @param {string} event
 * @param {object} target
 * @param {string|array|object} message
 * @param {string} origin
 * @returns {object}
 * @public
 */

PostIt.prototype.emit = function(event, target, message, origin) {
	var that = this;
	var eventOrigin = window.location.href;
	var symbol = 'postit';

	switch (Object.prototype.toString.call(message)) {
		case '[object Function]':
			console.warn(message + ' should either be an `Object`, `Array` or `String`.');

			return that;

		case '[object Object]':
			message.__postit = symbol;
			message.__id = that.id;
			message.__event = event;
			message.__origin = eventOrigin;
			message = JSON.stringify(message);

			break;

		default:
			message = JSON.stringify({
				__postit: symbol,
				__value: message,
				__id: that.id,
				__event: event,
				__origin: eventOrigin
			});
	}

	target.postMessage(message, origin);

	return that;
};

},{}]},{},[3])(3)
});

